export enum PollSaveType {
    Draft = 0,
    PendingApproval = 1,
    Approved = 2,
    ActionRequired = 3,
    Active = 4,
    Close = 5,
    Completed = 6,
    Cancelled = 7,
}